import React from 'react'

const ProfileInfo = ({ fullName, mobile, email, location}) => {
  return (
    <div className="tab-content pt-4 text-muted">
      <div className="tab-pane active" id="overview-tab" role="tabpanel">
        <div className="row">
          <div className="col-xxl-3">
            <div className="card">
              <div className="card-body">
                <h5 className="card-title mb-3">Info</h5>
                <div className="table-responsive">
                  <table className="table table-borderless mb-0">
                    <tbody>
                      <tr>
                        <th className="ps-0" scope="row">Full Name :</th>
                        <td className="text-muted">{fullName}</td>
                      </tr>
                      <tr>
                        <th className="ps-0" scope="row">Mobile :</th>
                        <td className="text-muted">{mobile}</td>
                      </tr>
                      <tr>
                        <th className="ps-0" scope="row">E-mail :</th>
                        <td className="text-muted">{email}</td>
                      </tr>
                      <tr>
                        <th className="ps-0" scope="row">Location :</th>
                        <td className="text-muted">{ location}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div> {/* col-xxl-3 */}
        </div> {/* row */}
      </div> {/* tab-pane */}
    </div>
  )
}

export default ProfileInfo